import { Goal, GoalSummary } from '@lumora/common';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface GoalsState {
  goals: (Goal | GoalSummary)[];
  currentGoal: Goal | GoalSummary | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: GoalsState = {
  goals: [],
  currentGoal: null,
  isLoading: false,
  error: null,
};

const goalsSlice = createSlice({
  name: 'goals',
  initialState,
  reducers: {
    setGoals: (state, action: PayloadAction<(Goal | GoalSummary)[]>) => {
      state.goals = action.payload;
    },
    setCurrentGoal: (
      state,
      action: PayloadAction<Goal | GoalSummary | null>
    ) => {
      state.currentGoal = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const { setGoals, setCurrentGoal, setLoading, setError } =
  goalsSlice.actions;
export default goalsSlice.reducer;
